(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["kestad-bundle"] && !Shopify.designMode) return;
  try {
    // Les sélecteurs couleur / taille vivent DANS l'offre choisie.
  // Pack d'une pièce : le formulaire natif garde la main (Shop Pay conservé).
  // Pack multiple : Shopify ne sait pas ajouter plusieurs variantes d'un coup,
  // on masque le formulaire natif et on poste les N articles nous-mêmes.
  class KestadBundle {
    constructor(racine) {
      this.racine = racine;
      this.d = JSON.parse(racine.querySelector('[data-kx-donnees]').textContent);
      this.bouton = racine.querySelector('[data-kx-ajout]');
      this.libelle = racine.querySelector('[data-kx-libelle]');
      this.erreur = racine.querySelector('[data-kx-erreur]');
      this.form = document.querySelector('form[action*="/cart/add"]');
      this.qte = 1;

      racine.addEventListener('change', (e) => {
        if (e.target.matches('.kx-bd__radio')) this.choisir(e.target);
        else if (e.target.matches('.kx-bd__sel')) {
          if (e.target.value) e.target.classList.remove('kx-bd__manque');
          // le client vient de trancher lui-même : cette ligne n'est plus auto-remplie
          if (e.target.dataset.r === 't') { delete e.target.dataset.kxAuto; this.reporterTaille(); }
          this.majLigne(e.target.closest('.kx-bd__ligne'));
        }
      });
      this.bouton.addEventListener('click', () => this.ajouter());

      const visibles = [...racine.querySelectorAll('.kx-bd__radio')].filter((r) => r.closest('[data-kx-opt]').offsetParent !== null);
      const coche = visibles.find((r) => r.checked) || visibles[0] || racine.querySelector('.kx-bd__radio:checked') || racine.querySelector('.kx-bd__radio');
      if (coche) { coche.checked = true; this.choisir(coche); }
    }

    // Un pack de six réclamait six tailles saisies une par une avant de pouvoir
    // commander. La taille de la première pièce se reporte donc sur les
    // suivantes ; toute ligne que le client a réglée lui-même est laissée intacte.
    reporterTaille() {
      const z = this.opt?.querySelector('[data-kx-corps]');
      if (!z) return;
      const sels = [...z.querySelectorAll('[data-r="t"]')];
      const source = sels[0]?.value;
      if (!source) return;
      for (const s of sels.slice(1)) {
        if (s.value && s.dataset.kxAuto !== '1') continue;
        s.dataset.kxAuto = '1';
        if (s.value === source) continue;
        s.value = source;
        this.majLigne(s.closest('.kx-bd__ligne'));
      }
    }

    get opt() { return this.racine.querySelector('.kx-bd__radio:checked')?.closest('[data-kx-opt]'); }

    choisir(radio) {
      this.qte = parseInt(radio.value, 10) || 1;
      const actif = radio.closest('[data-kx-opt]');
      // on vide les autres offres pour n'avoir qu'un seul jeu de sélecteurs
      this.racine.querySelectorAll('[data-kx-opt]').forEach((o) => {
        const z = o.querySelector('[data-kx-corps]');
        if (o !== actif) { z.innerHTML = ''; z.hidden = true; }
      });
      const z = actif.querySelector('[data-kx-corps]');
      const memo = [...z.querySelectorAll('.kx-bd__ligne')]
        .map((l) => [l.querySelector('[data-r="c"]').value, l.querySelector('[data-r="t"]').value]);
      z.innerHTML = '';
      if (this.d.libelles.titreChoix) {
        const t = document.createElement('p');
        t.className = 'kx-bd__soustitre';
        t.textContent = this.d.libelles.titreChoix;
        z.appendChild(t);
      }
      if (this.qte > 1 && this.d.libelles.noteTaille) {
        const n = document.createElement('p');
        n.className = 'kx-bd__notetaille';
        n.textContent = this.d.libelles.noteTaille;
        z.appendChild(n);
      }
      for (let i = 0; i < this.qte; i++) z.appendChild(this.ligne(i, memo[i]));
      z.hidden = false;
      this.reporterTaille();
      this.majBouton();
    }

    ligne(i, memo) {
      const l = document.createElement('div');
      l.className = 'kx-bd__ligne';
      const img = document.createElement('img');
      img.className = 'kx-bd__vignette';
      img.alt = ''; img.loading = 'lazy';

      const duo = document.createElement('div');
      duo.className = 'kx-bd__duo';
      const faire = (role, titre, valeurs, choisi) => {
        const s = document.createElement('select');
        s.className = 'kx-bd__sel';
        s.dataset.r = role;
        s.setAttribute('aria-label', `${titre} — pièce ${i + 1}`);
        const vide = document.createElement('option');
        vide.value = ''; vide.textContent = titre;
        s.appendChild(vide);
        valeurs.forEach((v) => {
          const o = document.createElement('option');
          o.value = typeof v === 'string' ? v : v.nom;
          o.textContent = o.value;
          s.appendChild(o);
        });
        if (choisi) s.value = choisi;
        else if (role === 'c' && valeurs.length) {
          // on décale d'une couleur à chaque pièce : le pack de 3 sort une de
          // chaque, le pack de 6 sort deux de chaque, le pack de 1 garde la 1re.
          const v = valeurs[i % valeurs.length];
          s.value = v.nom ?? v;
        }
        return s;
      };
      duo.append(
        faire('c', this.d.libelles.couleur, this.d.couleurs, memo?.[0]),
        faire('t', this.d.libelles.taille, this.d.tailles, memo?.[1]),
      );
      l.append(img, duo);
      queueMicrotask(() => this.majLigne(l));
      return l;
    }

    majLigne(l) {
      if (!l) return;
      const c = l.querySelector('[data-r="c"]').value;
      const img = l.querySelector('.kx-bd__vignette');
      const src = this.d.couleurs.find((x) => x.nom === c)?.image;
      if (src) { img.src = src; img.style.visibility = 'visible'; }
      else { img.removeAttribute('src'); img.style.visibility = 'hidden'; }
      this.majBouton();
    }

    lignes() {
      const z = this.opt?.querySelector('[data-kx-corps]');
      return z ? [...z.querySelectorAll('.kx-bd__ligne')].map((l) => ({
        c: l.querySelector('[data-r="c"]').value,
        t: l.querySelector('[data-r="t"]').value,
      })) : [];
    }

    variante(c, t) { return this.d.variantes.find((v) => v.c === c && v.t === t); }

    majBouton() {
      const L = this.lignes();
      const complet = L.length > 0 && L.every((x) => x.c && x.t);
      const dispo = complet && L.every((x) => this.variante(x.c, x.t)?.d);
      this.syncNatif(L, complet && dispo);
      // toujours cliquable : c'est le clic qui explique ce qui manque, pas un bouton grisé
      this.bouton.disabled = false;
      this.libelle.textContent = this.d.libelles.cta;
      this.erreur.hidden = true;
    }

    syncNatif(L, pret) {
      const solo = this.qte === 1;
      this.bouton.style.display = '';
      if (!this.form) return;
      // le bouton d'ajout natif reste masqué : le nôtre le remplace sur les trois packs
      this.form.querySelectorAll('button[name="add"]').forEach((el) => { el.style.display = 'none'; });
      // le paiement express ne vaut que pour le pack simple, où il porte une seule unité
      this.form.querySelectorAll('.shopify-payment-button, [data-shopify="payment-button"]').forEach((el) => {
        const cible = el.closest('.shopify-payment-button') || el;
        cible.style.display = solo ? '' : 'none';
      });
      if (!solo) return;
      const v = L[0] && this.variante(L[0].c, L[0].t);
      const champId = this.form.querySelector('input[name="id"], select[name="id"]');
      if (champId && v) { champId.value = v.id; champId.dispatchEvent(new Event('change', { bubbles: true })); }
      const champQ = this.form.querySelector('input[name="quantity"]');
      if (champQ) champQ.value = 1;
    }

    async ajouter() {
      const L = this.lignes();
      if (!L.length || !L.every((x) => x.c && x.t)) return this.dire(this.d.libelles.incomplet);
      const items = [];
      for (const x of L) {
        const v = this.variante(x.c, x.t);
        if (!v) return this.dire(this.d.libelles.incomplet);
        if (!v.d) return this.dire(this.d.libelles.epuise);
        items.push({ id: v.id, quantity: 1 });
      }
      try { JSON.parse(this.opt?.dataset.extras || '[]').forEach((x) => items.push({ id: x.id, quantity: x.q })); } catch (e) {}
      this.bouton.disabled = true;
      try {
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!r.ok) {
          const j = await r.json().catch(() => ({}));
          throw new Error(j.description || j.message || 'Ajout impossible');
        }
        const ou = this.racine.dataset.redirige;
        const tiroir = document.querySelector('theme-drawer#cart-drawer');
        /* Prix degressifs : chaque palier porte le code de reduction qui fait
           descendre le total au montant affiche sur la fiche. Shopify l'applique
           via /discount/CODE?redirect=..., puis enchaine sur la destination voulue.
           Des qu'un code existe on navigue : sinon il ne serait jamais applique. */
        const code = this.opt?.dataset.code?.trim();
        if (code) {
          const dest = ou === 'checkout' ? '/checkout'
            : ou === 'stay' ? window.location.pathname : '/cart';
          window.location.href = '/discount/' + encodeURIComponent(code)
            + '?redirect=' + encodeURIComponent(dest);
          return;
        }
        /* Le tiroir ne doit pas court-circuiter le reglage « Apres l'ajout » :
           tant qu'il passait avant, choisir « Aller au paiement » dans l'editeur
           de theme n'avait aucun effet. */
        if (ou !== 'checkout' && tiroir && window.__kxPanier) {
          window.__kxPanier(items);
          // filet de sécurité : si le thème n'a pas ouvert le tiroir, on l'ouvre
          setTimeout(() => { if (!tiroir.isOpen && typeof tiroir.open === 'function') tiroir.open(); }, 450);
          this.bouton.disabled = false;
          return;
        }
        if (ou === 'checkout') window.location.href = '/checkout';
        else if (ou === 'stay') window.location.reload();
        else window.location.href = '/cart';
      } catch (e) {
        this.dire(e.message);
        this.bouton.disabled = false;
      }
    }

    dire(m) {
      this.erreur.textContent = m;
      this.erreur.hidden = false;
      /* on surligne toutes les lignes incompletes, pas seulement la premiere :
         le client voit d'un coup ce qui lui reste a renseigner */
      const vides = [...this.racine.querySelectorAll('select')].filter((el) => !el.value);
      vides.forEach((el) => el.classList.add('kx-bd__manque'));
      if (vides[0]) {
        vides[0].focus({ preventScroll: true });
        vides[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }
  }

  const demarrer = () => document.querySelectorAll('[data-kx-bundle]').forEach((el) => {
    if (!el.dataset.pret) { el.dataset.pret = '1'; new KestadBundle(el); }
  });
  document.addEventListener('DOMContentLoaded', demarrer);
  document.addEventListener('shopify:section:load', demarrer);
  demarrer();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["kestad-taille-lien"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-kx-ouvre]');
    if (o) {
      const d = document.getElementById(o.dataset.kxOuvre);
      if (d?.showModal) d.showModal();
      return;
    }
    const f = e.target.closest('[data-kx-ferme]');
    if (f) document.getElementById(f.dataset.kxFerme)?.close();
  });
  // clic sur le fond : on ferme
  document.addEventListener('click', (e) => {
    const d = e.target;
    if (d.tagName !== 'DIALOG' || !d.classList.contains('kx-tl__modale')) return;
    const r = d.getBoundingClientRect();
    const dedans = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
    if (!dedans) d.close();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["kestad-video"] && !Shopify.designMode) return;
  try {
    (() => {
    const jouer = (v) => {
      const p = v.play();
      if (p && p.catch) p.catch(() => {});
    };
    const demarrer = (v) => {
      // deja charge : on relance simplement la boucle
      if (v.dataset.kxPret) { jouer(v); return; }
      v.dataset.kxPret = '1';
      v.src = v.dataset.src;
      v.load();
      jouer(v);
    };
    const init = () => {
      const cibles = document.querySelectorAll('[data-kx-boucle]:not([data-kx-vu])');
      if (!cibles.length) return;
      const reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduit || !('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver((entrees) => {
        for (const e of entrees) {
          if (e.isIntersecting) { demarrer(e.target); }
          else if (e.target.dataset.kxPret) { e.target.pause(); }
        }
      }, { rootMargin: '150px 0px' });
      cibles.forEach((v) => { v.dataset.kxVu = '1'; io.observe(v); });
    };
    init();
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:block:select', init);
  })();

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-kx-play]');
    if (!b) return;
    const zone = b.closest('[data-kx-video]');
    zone.dataset.joue = '1';
    const lien = zone.dataset.embed;
    if (lien) {
      let src = lien;
      if (/youtu/.test(lien)) {
        const id = lien.match(/(?:v=|youtu\.be\/|embed\/)([\w-]{6,})/)?.[1];
        if (id) src = `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`;
      } else if (/vimeo/.test(lien)) {
        const id = lien.match(/vimeo\.com\/(?:video\/)?(\d+)/)?.[1];
        if (id) src = `https://player.vimeo.com/video/${id}?autoplay=1`;
      }
      const f = document.createElement('iframe');
      f.src = src;
      f.allow = 'autoplay; fullscreen; picture-in-picture';
      f.setAttribute('allowfullscreen', '');
      f.title = b.getAttribute('aria-label') || 'Vidéo';
      zone.querySelector('.kx-vd__el')?.replaceWith(f);
      return;
    }
    const v = zone.querySelector('video');
    if (v) { v.play(); v.setAttribute('controls', ''); }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["kestad-videos"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-kx-play]');
    if (!b) return;
    const zone = b.closest('[data-kx-video]');
    zone.dataset.joue = '1';
    const lien = zone.dataset.embed;
    if (lien) {
      // YouTube / Vimeo : on n'insère l'iframe qu'au clic, jamais au chargement
      let src = lien;
      if (/youtu/.test(lien)) {
        const id = lien.match(/(?:v=|youtu\.be\/|embed\/)([\w-]{6,})/)?.[1];
        if (id) src = `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`;
      } else if (/vimeo/.test(lien)) {
        const id = lien.match(/vimeo\.com\/(?:video\/)?(\d+)/)?.[1];
        if (id) src = `https://player.vimeo.com/video/${id}?autoplay=1`;
      }
      const f = document.createElement('iframe');
      f.src = src;
      f.allow = 'autoplay; fullscreen; picture-in-picture';
      f.setAttribute('allowfullscreen', '');
      f.title = b.getAttribute('aria-label') || 'Vidéo';
      zone.querySelector('.kx-vd__el')?.replaceWith(f);
      return;
    }
    const v = zone.querySelector('video');
    if (v) { v.play(); v.setAttribute('controls', ''); }
  });
  } catch(e) { console.error(e); }
})();

})();
